<template>
  <div class="table">
    <div class="tableRow">
      <div class="tableHead-row">
        <div class="tableHead">KEY值</div>
        <div
          v-for="lang in langs"
          :key="lang"
          class="tableHead"
        >{{ langsMapping[lang] }}</div>
        <div class="tableHead">
          {{ this.env === 'DEV' ? '可修改單號' : '最近單號' }}
        </div>
      </div>
    </div>
    <RecycleScroller
      :items="sortedData"
      :item-size="40"
      class="scroller"
      key-field="_id"
      v-slot="{
        item: {
          _id,
          ticket,
          key,
          updateUser,
          timestamp,
          updateType,
          version,
          ...langs
        },
      }"
      page-mode
    >
      <div class="item" @click="handleClick(_id)">
        <div
          class="item-key"
          v-html="addKeywordsStyle(key)"
          @click="handleClickSelectAndCopy"
        ></div>
        <div
          v-for="(text, index) in sortLangs(langs)"
          :key="index"
          class="item-lang"
          :class="`${env === 'DEV' && 'item-cursor'}`"
          @click="
            hasUpdatePermission
              ? handleCellClick(_id, text, key, indexToLang(index))
              : null
          "
        >
          <div class="fullWidth-hint">
            <div
              v-if="fullwidthCheck(text, indexToLang(index))"
              class="symbol"
            ></div>
            <span v-html="addKeywordsStyle(text, indexToLang(index))"></span>
            <input
              type="text"
              v-if="idInput === _id && typeInput === indexToLang(index)"
              v-focus
              class="hideInput"
              @keyup.enter="$event.target.blur()"
              @blur="handleBlur(text, key)"
              v-model="textInput"
            />
          </div>
        </div>
        <div
          class="item-ticket"
          v-html="addKeywordsStyleForTicket(ticket, version)"
          @click="
            hasUpdatePermission && editTicketAllowed(version)
              ? handleTicketCellClick(_id, ticket)
              : null
          "
        ></div>
        <!-- <span
          v-if="user"
          class="item-delete icon-cancel"
          @click="handleDelete(key)"
        >
        </span> -->
        <!-- <div class="tool-tip-text" v-if="user && dev">
          {{ updateUser }} {{ updateType }} {{ soltTime(timestamp) }}
        </div> -->
      </div>
    </RecycleScroller>
    <modal
      name="edit"
      :resizable="true"
      :styles="{ padding: '10px' }"
      height="600px"
      @before-close="beforeClose"
    >
      <div class="edit_header">
        <span class="">{{ `${langKey}` }}</span>
        <span>{{ `${getCurrentLangStr}` }}</span>
      </div>
      <div>
        <input
          type="text"
          v-model="ticket"
          @input="checkTicket(ticket)"
          @keypress.enter.prevent
          placeholder="請輸入Jira ticket(必填)"
        />
      </div>
      <textarea
        :style="{
          width: '100%',
          height: 'calc(100% - 140px)',
          resize: 'none',
          marginTop: '10px',
        }"
        v-model="textInput"
      />
      <div class="control_row">
        <button
          class="update__btn"
          @click="updateCell"
          :disabled="
            !ticket || !ticket.trim() || !textInput || !textInput.trim()
          "
        >
          更新翻譯
        </button>
      </div>
    </modal>
    <modal
      name="edit_ticket"
      :resizable="true"
      :styles="{ padding: '10px' }"
      height="200px"
      @before-close="beforeClose"
    >
      <div class="edit_header">
        <span class="">修改Jira Card單號</span>
      </div>
      <div style="text-align: center">
        <div style="margin-bottom: 10px">修改前: {{ `${textInput}` }}</div>
        <span>修改後: </span>
        <input
          type="text"
          v-model="ticket"
          @input="checkTicket(ticket)"
          @keypress.enter.prevent
          placeholder="請輸入Jira ticket(必填)"
        />
      </div>
      <div class="control_row">
        <button
          class="update__btn"
          @click="updateTicket"
          :disabled="
            !ticket ||
            !ticket.trim() ||
            !textInput ||
            !textInput.trim() ||
            ticket == textInput ||
            !this.isTicketValid
          "
        >
          更新單號
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { hasSpecifiedPermission, permission } from '@/utils/permission-type';
import { regex, regexRull } from '@/utils/regex';
import { mapGetters } from 'vuex';

export default {
  name: 'Table',
  data() {
    return {
      idInput: null,
      idModal: null,
      typeInput: '',
      textInput: '',
      langKey: '',
      ticket: '',
      dev: sessionStorage['dev'] === 'true',
      result: [],
      delay: 400,
      clicks: 0,
      timer: null,
      isTicketValid: false,
    }
  },
  computed: {
    ...mapGetters([
      'sortedData',
      'keyword',
      'isModal',
      'type',
      'langs',
      'user',
      'langsMapping',
      'devVersion',
      'qaVersion',
      'env',
    ]),
    getCurrentLangStr() {
      return this.typeInput ? this.langsMapping[this.typeInput] : ''
    },
    hasUpdatePermission() {
      return hasSpecifiedPermission(
        permission.UPDATE,
        this.user?.permissions ?? []
      )
    },
  },
  methods: {
    // pc
    beforeClose() {
      this.ticket = ''
    },
    editCell(_id, text, key, type) {
      if (this.env === 'DEV') {
        this.idModal = _id
        this.textInput = text
        this.langKey = key
        this.typeInput = type
        this.$modal.show('edit')
      }
    },
    editTicket(_id, text) {
      if (this.env === 'DEV') {
        this.idModal = _id
        this.textInput = text
        this.$modal.show('edit_ticket')
      }
    },
    editTicketAllowed(version) {
      // Unapproved keys live above the QA watermark (write-then-increment).
      return this.env === 'DEV' && version > this.qaVersion
    },
    handleDblclick(_id, text, type) {
      this.idInput = _id
      this.textInput = text
      this.typeInput = type
    },
    checkTicket(ticket) {
      this.isTicketValid = /[A-Za-z]{2,3}-\d{1,10}/.test(ticket)
    },
    handleCellClick(_id, text, key, type) {
      this.clicks++
      if (this.clicks === 1) {
        this.timer = setTimeout(() => {
          // this.handleClickSelectAndCopy(e);
          this.editCell(_id, text, key, type)
          this.clicks = 0
        }, this.delay)
      }
      // else {
      //   clearTimeout(this.timer);
      //   this.handleDblclick(_id, text, type);
      //   this.clicks = 0;
      // }
    },
    handleTicketCellClick(_id, text) {
      this.clicks++
      if (this.clicks === 1) {
        this.timer = setTimeout(() => {
          // this.handleClickSelectAndCopy(e);
          this.editTicket(_id, text)
          this.clicks = 0
        }, this.delay)
      }
    },
    handleBlur(text, key) {
      if (text !== this.textInput) {
        this.$store.dispatch('updateData', {
          id: this.idInput,
          body: {
            key,
            [this.typeInput]: this.textInput,
          },
        })
      }
      this.idInput = null
    },
    updateCell() {
      if (this.textInput.trim() === '') {
        this.$store.dispatch('handleMessage', {
          success: false,
          text: `${this.langKey} ${
            this.langsMapping[this.typeInput]
          } 更新語言不能為空`,
        })
        return
      }
      if (!this.isTicketValid) {
        this.$store.dispatch('handleMessage', {
          success: false,
          text: `${this.langKey} ${
            this.langsMapping[this.typeInput]
          } 單號格式錯誤`,
        })
        return
      }
      this.$store
        .dispatch('updateData', {
          key: this.langKey,
          ticket: this.ticket,
          [this.typeInput]: this.textInput.trim(),
        })
        .then((result) => {
          if (result) {
            this.idModal = null
            this.ticket = ''
            this.$modal.hide('edit')
          }
        })
    },
    updateTicket() {
      if (!this.isTicketValid) {
        this.$store.dispatch('handleMessage', {
          success: false,
          text: `單號格式錯誤`,
        })
        return
      }
      this.$store
        .dispatch('updateTicket', {
          id: this.idModal,
          newTicket: this.ticket,
        })
        .then((result) => {
          if (result) {
            this.idModal = null
            this.ticket = ''
            this.$modal.hide('edit_ticket')
          }
        })
    },
    addKeywordsStyle(text, type = 'key') {
      if (this.keyword === '' || this.type !== type) return text
      const keywordReplaced = this.keyword.replace(
        /[.*+\-?^${}()|[\]\\]/g,
        '\\$&'
      )
      return text.replace(
        new RegExp(keywordReplaced, 'gi'),
        (text) => `<span style="color:red;">${text}</span>`
      )
    },
    addKeywordsStyleForTicket(text, version) {
      if (this.env === 'DEV' && version <= this.qaVersion) {
        text = ''
      }
      if (this.keyword === '' || this.type !== 'ticket') {
        return text
      }
      const keywordReplaced = this.keyword.replace(
        /[.*+\-?^${}()|[\]\\]/g,
        '\\$&'
      )
      return text.replace(
        new RegExp(keywordReplaced, 'gi'),
        (text) => `<span style="color:red;">${text}</span>`
      )
    },
    // mob
    handleClick(_id) {
      this.$store.commit('setIdModal', _id)
      this.$store.commit('setIsModal', true)
    },
    handleClickSelectAndCopy(e) {
      if (window.innerWidth < 768) return
      // IE
      if (document.body.createTextRange) {
        const range = document.body.createTextRange()
        range.moveToElementText(e.target)
        range.select()
      } else if (window.getSelection) {
        const selection = window.getSelection()
        const range = document.createRange()
        range.selectNodeContents(
          e.target.tagName == 'SPAN' ? e.target.parentNode : e.target
        )
        selection.removeAllRanges()
        selection.addRange(range)
      }
      document.execCommand('copy')
      this.$store.dispatch('handleMessage', {
        success: true,
        text: '已複製到剪貼簿',
      })
    },
    sortLangs(langs) {
      const langsFiltered = this.langs.map((lang) => {
        if (langs[lang]) {
          return langs[lang]
        }
        return ''
      })
      return langsFiltered
    },
    fullwidthCheck(text, lang) {
      if (lang === 'zh_CN' || lang === 'zh_HK') {
        return false
      }
      return regex(regexRull.fullWidth, text)
    },
    indexToLang(index) {
      return this.langs[index]
    },
    handleDelete(key) {
      if (window.confirm(`確定刪除 ${key} ？`)) {
        this.$store.dispatch('deleteData', { key })
      }
    },
    soltTime(time) {
      return time ? this.$dayjs(time).format('YYYY-MM-DD') : ''
    },
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
    },
  },
}
</script>

<style lang="scss">
.tableRow {
  display: none;
  @media screen and (min-width: 768px) {
    width: 100%;
    // height: 40px;
    display: flex;
    // overflow: hidden;
    text-align: justify;
    flex-direction: column;
    margin-bottom: -1px;
    position: sticky;
    top: 0;
    color: #fff;
    background-color: #343a40;
    justify-content: center;
    z-index: 1;
    border-left: 1px black solid;
    border-top: 1px black solid;
    border-bottom: 1px black solid;
  }
  .tableHead-row {
  .tableHead {
    padding: 2px 5px !important;
  }
    width: 100%;
    height: 40px;
    display: flex;
    border-right: 1px black solid;
    .tableHead {
      width: 100%;
      padding: 5px;
      display: flex;
      justify-content: center;
    }
    @media screen and (min-width: 768px) {
      padding: 2px;
    }
  }
}
.scroller {
  height: 100%;
  border: 1px black solid;
  border-right: none;
  border-bottom: none;
}
.item {
  height: 40px;
  display: flex;
  overflow: hidden;
  border-bottom: 1px black solid;
  position: relative;
  .item-key {
    white-space: nowrap;
    overflow-x: scroll !important;
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
    &:hover,
    &:active {
      scrollbar-width: auto;;
      -ms-overflow-style: auto;
      &::-webkit-scrollbar {
        display: block;
        height: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 4px;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
  }
  &:hover {
    background: #e0e1e2;
    .item-delete {
      @media screen and (min-width: 768px) {
        display: flex;
      }
    }
    .tool-tip-text {
      display: flex;
      position: absolute;
      right: 24px;
      background-color: #db2828;
      color: white;
      padding: 5px 10px;
      text-align: center;
      font-size: 12px;
      //   z-index: 10;
      opacity: 80%;
      text-shadow: 1px 1px 2px #5e0212;
    }
  }
  .tool-tip-text {
    display: none;
  }
  &.item-deleted {
    background: #f5b4b4;
  }
  .item-key,
  .item-lang,
  .item-ticket {
    padding: 2px 5px !important;
    width: 100%;
    // padding: 5px;
    overflow: hidden;
    position: relative;
    border-right: 1px black solid;
    @media screen and (min-width: 768px) {
      padding: 2px;
    }
    .fullWidth-hint {
      height: 100%;
      .symbol {
        position: absolute;
        right: 0;
        top: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 15px 15px 0;
        border-color: transparent #ff0000 transparent transparent;
      }
    }
  }
  .item-cursor {
    cursor: pointer;
  }
  .item-lang {
    display: none;
    @media screen and (min-width: 768px) {
      display: block;
    }
  }
  .hideInput {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    padding-left: 4px;
    z-index: 1;
    // &:focus {
    //   outline: #28a745 1px solid;
    // }
  }
  .item-delete {
    width: 24px;
    height: 24px;
    background: #db2828;
    color: white;
    position: absolute;
    right: 0;
    top: 0;
    display: none;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    cursor: pointer;
    &:hover {
      background: #d01919;
    }
  }
  @media screen and (min-width: 768px) {
    height: 40px;
    flex-wrap: nowrap;
  }
}
.edit_header {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
}
.control_row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  .update__btn {
    background-color: #21ba45;
    color: #fff;
    box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
    cursor: pointer;
    padding: 10px 20px;
    border-radius: 5px;
    &:hover {
      background-color: #16ab39;
    }
    &:disabled {
      background: #cccccc;
      cursor: default;
    }
  }
}
</style>
